import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {MatTabChangeEvent} from '@angular/material/tabs';

import {NavigationService} from './navigation.service';
import {DrawViewService} from '../../Editor/DrawView/draw-view.service';
import {ApplicationService} from '../application.service';
import {ViewComponent} from '../../../../../surface3d/src/lib/3DView/view.component';


@Component({
    selector: 'burncase-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit, AfterViewInit {

    // @ViewChild('mainFlexBox') mainFlexBox;
    //
    @Output() drawView = new EventEmitter<boolean>();
    //
    // @ViewChild('mainToggGroupp') mainToggGroup;
    @ViewChild('mainSurfaceView') mainSurfaceView;
    @ViewChild('surfaceView', {static: true}) surfaceView: ViewComponent;
    private ios: boolean;

    constructor(public navigationService: NavigationService,
                public applicationService: ApplicationService,
                public drawViewService: DrawViewService) {
    }

    ngOnInit(): void {
        this.navigationService.disableScrolling();
        // check if device is ios
        this.ios = /iPhone|iPad/i.test(window.navigator.userAgent);
    }

    ngAfterViewInit(): void {
        // @ts-ignore needed to calculate slider speed
        // this._sliderWidth = this.slider._elementRef.nativeElement.getBoundingClientRect().width;
        this.drawViewService.initializeShapeView(this.surfaceView);

        if (this.ios) {
            this.checkIOsDevice();
        }
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    // todo wrong name mstiftin
    /**
     * Disables Scrolling on mobile apple devices
     */
    public onResize() {
        this.navigationService.disableIosScrolling();
    }

    /**
     * triggers functions based on current view
     * index 0 = Model, index 1 = Draw, index 2 = Result
     */
    public collectData(event: MatTabChangeEvent) {
        if (event.index === 1) {
            this.hideSurfaceView(false);
            // this.setTabGroupSize('110px');
            this.checkIOsDevice();

            if (this.navigationService.getCurModelMode() !== 1) {
                this.navigationService.loadDrawViewResetControls();
            } else {
                this.navigationService.updateViewSize();
            }

        } else if (event.index === 2) {

            this.navigationService.resetModel();
            this.resetTransformButton();

            if (this.navigationService.getCurModelMode() !== 1) {
                this.navigationService.loadDrawViewResetControls();
            }

            this.navigationService.collectBurnData();

            this.hideSurfaceView(true);
            // this.setTabGroupSize('100%');

        } else {
            this.hideSurfaceView(false);
            // this.setTabGroupSize('300px');
            this.checkIOsDevice();

            if (this.navigationService.getCurModelMode() !== 0) {
                this.resetTransformButton();
                this.navigationService.loadModelViewResetControls();
                this.navigationService.deactivateModelSelection();
            }

            this.navigationService.updateViewSize();
        }

        // hides the draw view on screen change
        this.drawView.emit(true);
    }

    /**
     * Checks if current device is IOs device and depending on that sets canvas size.
     */
    private checkIOsDevice() {
        if (this.ios === true) {
            // const height = this.mainFlexBox.nativeElement.offsetHeight - this.mainToggGroup.nativeElement.offsetHeight;
            // this.setSurfaceViewSize('100%', height + 'px');
        } else {
            // this.setSurfaceViewSize('100%', '100%');
        }
    }

    /**
     * Select the transform button from draw-view.
     */
    private resetTransformButton() {
        // set selected button to pan mode
        this.drawViewService.interactionMode = 'transform';
    }

    /**
     * Sets the width and height of the surface-view from the html file.
     * @param width which should be set.
     * @param height which should be set.
     */
    // private setSurfaceViewSize(width: string, height: string) {
    //     this.mainSurfaceView.nativeElement.style.height = height;
    //     this.mainSurfaceView.nativeElement.style.width = width;
    // }

    /**
     * Sets the height of the tab-group from the html file.
     * @param height which should be set.
     */
    // private setTabGroupSize(height: string) {
    //     this.mainToggGroup.nativeElement.style.height = height;
    // }

    /**
     * Shows or hides the surface-view from the html file.
     * @param hide if true surface-view is hidden.
     */
    private hideSurfaceView(hide: boolean) {
        this.mainSurfaceView.nativeElement.hidden = hide;
    }
}
